import React, { useEffect, useMemo, useState } from "react";
import { getLatestDonations } from "../services/AnimalSplitCore";
import "./DonationWheel.css";
import { getStableAnimalEmoji } from "../utils/utils";
import { useScene } from "./scene/SceneContext";

export default function DonationWheel() {
  const [donations, setDonations] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const { variant } = useScene();

  useEffect(() => {
    loadDonations();
  }, []);

  const loadDonations = async () => {
    try {
      const res = await getLatestDonations();
      if (res && res.length > 0) {
        setDonations(res);
        setIsVisible(true);
      }
    } catch (error) {
      console.error("Failed to load donations", error);
    }
  };

  // Rotate donations every 3 seconds
  useEffect(() => {
    if (donations.length > 1) {
      const interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % donations.length);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [donations]);

  const currentDonation = donations[currentIndex];
  const mascot = useMemo(() => {
    const seed = `${currentDonation?.alias || "anon"}:${currentDonation?.amount || 0}`;
    return getStableAnimalEmoji(seed);
  }, [currentDonation]);

  if (!isVisible || donations.length === 0) {
    return null;
  }

  return (
    <div className={`donation-wheel donation-wheel--${variant}`}>
      <div
        className="donation-item"
        key={`${currentDonation?.alias || "anon"}-${currentDonation?.amount || 0}-${currentDonation?.note || ""}`}
      >
        <span className="donation-mascot" aria-hidden="true">
          {mascot}
        </span>
        <div className="donation-info">
          <span className="donation-name">{currentDonation.alias || "Anonymous"}</span>
          <span className="donation-sep">•</span>
          <span className="donation-value">${(currentDonation.amount / 100).toFixed(2)}</span>
        </div>
        {currentDonation.note && (
          <span className="donation-message">{currentDonation.note}</span>
        )}
      </div>
    </div>
  );
}
